import React from 'react';
// components
import { View, Text } from '@upstox/upstox-ui';

// assets
import ChromeLogo from 'assets/chrome_icon.svg';
import SafariLogo from 'assets/safari_icon.svg';
import EdgeLogo from 'assets/edge_icon.svg';
import FirefoxLogo from 'assets/firefox_icon.svg';
import OperaLogo from 'assets/opera_icon.svg';

// styles
import * as css from './styles';

const BrowsersList = () => (
  <View css={css.browserList}>
    <View css={css.browserLogoContainer}>
      <img alt="Chrome logo" src={ChromeLogo} draggable={false} />
      <Text css={css.browserName}>Chrome</Text>
    </View>
    <View css={css.browserLogoContainer}>
      <img alt="Safari logo" src={SafariLogo} draggable={false} />
      <Text css={css.browserName}>Safari</Text>
    </View>
    <View css={css.browserLogoContainer}>
      <img alt="Firefox logo" src={FirefoxLogo} draggable={false} />
      <Text css={css.browserName}>Firefox</Text>
    </View>
    <View css={css.browserLogoContainer}>
      <img alt="Opera logo" src={OperaLogo} draggable={false} />
      <Text css={css.browserName}>Opera</Text>
    </View>
    <View css={css.browserLogoContainer}>
      <img alt="Edge logo" src={EdgeLogo} draggable={false} />
      <Text css={css.browserName}>Edge</Text>
    </View>
  </View>
);

export default React.memo(BrowsersList);
